<template>
    <div>
        <modifier :index="currentSurface" :arranged="this.arranged && !this.slatsCreating" />
        <surface-list v-if="manySurfaces" @current="currentSurface = $event"/>
        <v-btn color="primary" :disabled="!this.arranged || this.slatsCreating" @click="sendSlats">{{ $t('base.next') }}</v-btn>
        <v-btn @click="$emit('abort')" text>{{ $t('base.back') }}</v-btn>
    </div>
</template>

<script>
    import Modifier from "@/components/workspace/Modifier";
    import SurfaceList from "@/components/workspace/SurfaceList";

    export default {
        name: "Editor",
        components: {Modifier, SurfaceList},
        props: ['polygon', 'arranged'],
        computed: {
            manySurfaces() {
                return this.$store.state.configurator.surfaces.length > 1
            },
        },
        data() {
            return {
                currentSurface: 0,
                slatsCreating: false
            }
        },
        methods: {
            sendSlats() {
                this.slatsCreating = true
                this.$http.post('terrace/slats', this.$store.state.configurator.surfaces.map(surface => {
                    return {
                        id: surface.id,
                        segments: surface.edges.map(edge => edge.segment)
                    }
                }))
                    .then(({ data }) => {
                        this.slatsCreating = false
                        this.$store.commit('assignProjects', data)
                        this.$emit('complete')
                    })
                    .catch(() => {
                        this.slatsCreating = false
                    })
            }
        }
    }
</script>

<style scoped>

</style>
